import { Button, Table, Row, Col, Typography, DatePicker, Card } from "antd";
import { useEffect, useRef, useState, } from "react";
import api from "../../API";
import dayjs from 'dayjs';
import { ExportOutlined } from "@ant-design/icons";

function Billing() {
  const user = JSON.parse(localStorage.getItem('user'));
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [dueDate, setDueDate] = useState(dayjs());
  const [startDate, setStartDate] = useState(null);
  const dataOnTable = useRef([]);
  const originalMessages = useRef([]);
  const columns = [
    {
      title: "Message Type",
      dataIndex: "messageType"
    },
    {
      title: "Volume",
      dataIndex: "volume"
    },
    {
      title: "Estimated Cost (VND)",
      dataIndex: "estimatedCost"
    },
  ];

  useEffect(() => {
    setLoading(true);
    api.list_all_success_messages(user?.userId, user?.parentId)
    .then(messages => {
      if(!messages || messages.length === 0) return;
      originalMessages.current = messages;
      const [volumeCons, volumeTrans, volumePro] = messages.reduce((prevArr, msgObj) => {
        return [
          msgObj?.consultingTplId? prevArr[0] + 1: prevArr[0],
          msgObj?.transactionalTplId? prevArr[1] + 1: prevArr[1],
          msgObj?.promotionTplId? prevArr[2] + 1: prevArr[2]
        ]
      },[0,0,0]);
      dataOnTable.current = [
        {key: 0, messageType: "Consultant", volume: volumeCons, estimatedCost: volumeCons*55},
        {key: 1, messageType: "Transaction", volume: volumeTrans, estimatedCost: volumeTrans*165},
        {key: 2, messageType: "Promotion", volume: volumePro, estimatedCost: "-"}
      ]
      setDataSource(dataOnTable.current); 
    })
    .catch((err) => console.log(err.message))
    .finally(() => setLoading(false))
  },[])

  function handleExportAsCsv() {
    const csvString = [
      columns.map(column => column.title),
      ...dataSource.map(item => Object.keys(item).slice(1).map(k => item[k]))
    ]
    .map(row => row.join(","))
    .join("\n");
    const blob = new Blob([csvString], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'download.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  function handleDatesChange(dates) {
    if(!dates) { 
      setDataSource(dataOnTable.current);
      setStartDate(null);
      setDueDate(dayjs());
      return;
    }
    const headDate = dates[0];
    const lastDate = dates[1];
    const [volumeCons, volumeTrans, volumePro] = originalMessages.current.reduce((prevArr, msgObj) => {
      const msgDate = dayjs(msgObj?.sentAt);
      if(msgDate.isAfter(headDate,'day') && msgDate.isBefore(lastDate,'day')){
        return [
          msgObj?.consultingTplId? prevArr[0] + 1: prevArr[0],
          msgObj?.transactionalTplId? prevArr[1] + 1: prevArr[1],
          msgObj?.promotionTplId? prevArr[2] + 1: prevArr[2]
        ]
      }
      return prevArr;
    },[0,0,0]);
    setDataSource([
        {key: 0, messageType: "Consultant", volume: volumeCons, estimatedCost: volumeCons*55},
        {key: 1, messageType: "Transaction", volume: volumeTrans, estimatedCost: volumeTrans*165},
        {key: 2, messageType: "Promotion", volume: volumePro, estimatedCost: "-"}
    ]); 
    setDueDate(lastDate);
  }

  const onCalendarChange = (dates) => {
    if (dates && dates[0]) {
      setStartDate(dates[0]);
    }
  };

  const disabledEndDate = (current) => {
    if (!startDate) {
      return false;
    }
    const maxDate = dayjs(startDate).add(2, 'month').endOf('month');
    return current && (current.isBefore(startDate, 'day') || current.isAfter(maxDate, 'day'));
  };

  return (
    <Card 
      style={{height: '100%', margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
      title={
        <Typography.Title level={5} style={{margin: 0}}>Billing Details</Typography.Title>
      }
      loading={loading}
      extra={<Button 
        type="primary" 
        icon={<ExportOutlined />}
        style={{padding:15}}
        onClick={handleExportAsCsv}
        >Export CSV</Button>}
    >
      <Row gutter={[16,16]}  align="middle">
        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
          <DatePicker.RangePicker onCalendarChange={onCalendarChange} onChange={handleDatesChange} style={{width: '100%',}} disabledDate={disabledEndDate}/>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Table  
            bordered
            scroll={{x: 1000}}
            columns= {columns} 
            style={{marginTop: 16, width: '100%'}} 
            dataSource={dataSource}
            loading={loading}
            pagination={false}/>
        </Col>
      </Row>
      <Row>
        <Col span={24} style={{textAlign: "right", marginTop: 16}}>
          <Typography.Text style={{display: 'block'}}>Invoice Balance (VND): {dataSource.reduce((prevResult, obj) => (typeof obj.estimatedCost !== 'string')?  prevResult + obj.estimatedCost: prevResult, 0)}</Typography.Text>
          <Typography.Text style={{display: 'block'}}>Due Date: {dayjs(dueDate).format('DD/MM/YYYY')}</Typography.Text>
        </Col>
      </Row>
    </Card>
  )
}

export default Billing;